<template>
  <div class="bg-EXPONDO-white flex flex-col gap-2 rounded p-2 border border-EXPONDO-grey-10">
    <div
      v-if="title"
      class="font-bold"
    >
      {{ title }}
    </div>
    <slot />
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'CartSection',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
});

</script>
